// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import usePublishHeightVariable from "@store/Framework/Common/Hooks/usePublishHeightVariable";
import { siteBannersHeightVariable } from "@store/Framework/Common/Utilities/siteBanners";
import MaintenanceBanner, { MaintenanceBannerPresentationProps } from "@store/Library/Components/MaintenanceBanner";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC, useRef } from "react";

export interface SiteBannersPresentationProps extends ExpandStyles<SiteBannersStyles> {}

export interface SiteBannersProps extends SiteBannersPresentationProps {}

export interface SiteBannersStyles {
    wrapper?: InjectableCss;
    maintenanceBanner?: MaintenanceBannerPresentationProps;
}

export const siteBannersStyles: SiteBannersStyles = {};

/**
 * Holds the banners shown above every page. Its height is published so full-height layouts can subtract it.
 */
const SiteBanners: FC<SiteBannersProps> = ({ extendedStyles, overridedStyles }) => {
    const styles = useExpandProps(siteBannersStyles, extendedStyles, overridedStyles);
    const wrapperRef = useRef<HTMLDivElement>(null);

    usePublishHeightVariable(wrapperRef, siteBannersHeightVariable);

    return (
        <StyledWrapper {...styles.wrapper} ref={wrapperRef} data-test-selector="siteBanners">
            <MaintenanceBanner {...styles.maintenanceBanner} />
        </StyledWrapper>
    );
};

export default SiteBanners;
